import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import RevenuePage from "./pages/RevenuePage";
import ManagementPage from "./pages/ManagementPage";
import DebtPage from "./pages/DebtPage";
import DriverPage from "./pages/DriverPage";
import { useAuth } from "./hooks/useAuth";
import { useRevenueRows } from "./hooks/useRevenueRows";
import { DateScrollProvider } from "./contexts/DateScrollContext";

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <p className="text-slate-500">Đang tải...</p>
    </div>
  );
}

function RevenueAppPage() {
  const { user, authLoading, logout } = useAuth();
  const { rows, setRows, loading, error, loadData } = useRevenueRows(user);

  const normalizedRole = user?.role?.toLowerCase();
  const isDriver = normalizedRole === "driver";
  const isAccounting = normalizedRole === "accounting";
  const canViewDebt = isAccounting;

  if (authLoading) return <LoadingScreen />;

  // Not logged in -> về trang login chung của client
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <DateScrollProvider>
      <Routes>
        {isDriver ? (
          <>
            <Route path="driver" element={<DriverPage user={user} />} />
            <Route path="*" element={<Navigate to="driver" replace />} />
          </>
        ) : (
          <Route
            element={
              <MainLayout
                user={user}
                onLogout={logout}
                loading={loading}
                authLoading={authLoading}
                canViewDebt={canViewDebt}
                onRefresh={loadData}
                rows={rows}
              />
            }
          >
          <Route
            index
            element={
              <RevenuePage
                rows={rows}
                onRowsChange={setRows}
                loading={loading}
                error={error}
                userRole={user.role}
                onRefresh={loadData}
              />
            }
          />
          <Route
            path="manage"
            element={<ManagementPage rows={rows} userRole={user.role} />}
          />
          <Route
            path="debt"
            element={
              canViewDebt ? (
                <DebtPage rows={rows} />
              ) : (
                <Navigate to="." replace />
              )
            }
          />
          <Route path="*" element={<Navigate to="." replace />} />
        </Route>
      )}
    </Routes>
    </DateScrollProvider>
  );
}

export default RevenueAppPage;

